<div class="content-section implementation">
  <div class="card">
    <p-table
      #dt
      [value]="inputTableData"
      class="p-datatable-gridlines , p-datatable-striped, p-datatable-sm"
      dataKey="id"
      [rowTrackBy]="trackByStepId"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[10, 25, 50]"
      [reorderableColumns]="true"
      (onRowReorder)="onRowReorder($event)"
      (onEditInit)="onEditInit($event)"
      (onEditComplete)="onEditComplete($event)">
      <!-- <ng-template pTemplate="caption">
      <div class="p-d-flex">
        <button type="button" pButton pRipple icon="pi pi-file-o" (click)="dt.exportCSV()" class="p-mr-2 m-r-5" pTooltip="CSV" tooltipPosition="bottom"></button>
        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="onExportExcel()" class="p-button-success p-mr-2 m-r-5" pTooltip="XLS" tooltipPosition="bottom"></button>
        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="onExportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
        <button type="button" pButton pRipple icon="pi pi-filter" (click)="dt.exportCSV({selectionOnly:true})" class="p-button-info p-ml-auto" pTooltip="Selection Only" tooltipPosition="bottom"></button>
      </div>
    </ng-template> -->

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col style="width: 3.75%" />
          <col style="width: 3.75%" />
          <col style="width: 18.75%" />
          <col style="width: 18.75%" />
          <col style="width: 11.25%" />
          <col style="width: 11.25%" />
          <col style="width: 11.25%" />
          <col style="width: 120px" />
          <col style="width: 120px" />
          <!-- <col style="width:13.25%">  -->
          <!-- <col style="width:75px"> -->
          <col style="width: 130px" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th pReorderableColumn>Id</th>
          <th pReorderableColumn>Description</th>
          <th pReorderableColumn>Expected Result</th>
          <th pReorderableColumn>Data</th>
          <th pReorderableColumn>Notes</th>
          <th pReorderableColumn>Actual Result</th>
          <th pReorderableColumn>Attachment</th>
          <th pReorderableColumn>Status</th>
          <!-- <th pReorderableColumn> Bugs</th> -->
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-testData let-index="rowIndex">
        <tr [pReorderableRow]="index" [pReorderableRowDisabled]="readOnly">
          <td>
            <span class="pi pi-bars text-align-left-top" pReorderableRowHandle></span>
          </td>

          <td class="text-align-center-top">{{ testData.id }}</td>

          <!-- description / expectedResult / data / notes / actualResult all render the same
               rich-text cell and differed only in which property they bound, so they are
               generated from one block. The td stays inside the loop rather than the cell being
               pulled into a shared ng-template: p-cellEditor injects EditableColumn from its
               declaration position, so hoisting it out of the td would break inline editing. -->
          @for (field of richTextStepFields; track field) {
          <td pEditableColumn [pEditableColumnDisabled]="readOnly" [pFocusCellSelector]="'.ql-editor'" [attr.data-step-id]="testData.id" [attr.data-step-field]="field" class="text-align-left-top">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <!-- floatingToolbar: these cells are the narrowest surface the rich text field
                     is mounted on (11.25% of the panel for Data/Notes/Actual Result), far below
                     the toolbar's own width, so its toolbar has to float clear of the column
                     rather than be clipped by it. -->
                <app-rich-text-field [value]="testData[field]" [projectId]="projectId" [workspaceId]="workspaceId" [nodeInstanceId]="nodeData?.id || ''" [attachmentDialogContext]="'test-step'" [attachmentDialogData]="testData" [imageNamePrefix]="stepImageNamePrefix(testData)" [floatingToolbar]="true" (valueChange)="testData[field] = $event" (imageAttached)="onStepFieldImageAttached(testData, $event)"></app-rich-text-field>
              </ng-template>
              <ng-template pTemplate="output">
                @if (isRichTextHtml(testData[field])) {
                <div class="cell-html-preview" [innerHTML]="getResolvedFieldHtml(testData[field])" (click)="onFieldPreviewClick($event)"></div>
                } @else {
                <span class="cell-html-preview" style="white-space: pre-line">{{ testData[field] }}</span>
                }
              </ng-template>
            </p-cellEditor>
          </td>
          }


          <td pEditableColumn [pEditableColumnDisabled]="readOnly" [pFocusCellSelector]="'a'" [attr.data-step-id]="testData.id" data-step-field="attachments" class="text-align-left-top">
            <p-cellEditor (click)="onLoadUploadComponent(index)">
              <ng-template pTemplate="input" class="attachmentField">
                <a tabindex="0">
                  <mat-icon>attach_file</mat-icon>
                  <label> {{ onGetAttachmentCount(index) }}</label>
                  <label #fileCount>{{ numberOfFiles }}</label>
                </a>
                <label for="fileCount">{{ numberOfFiles }}</label>
              </ng-template>
              <ng-template pTemplate="output">
                <mat-icon>attach_file</mat-icon>
                <label> {{ onGetAttachmentCount(index) }}</label>
                <label #fileCount>{{ numberOfFiles }}</label>
              </ng-template>
            </p-cellEditor>
          </td>

          <td pEditableColumn [pEditableColumnDisabled]="readOnly" [pFocusCellSelector]="'.p-select-label'" [attr.data-step-id]="testData.id" data-step-field="teststatus" class="text-align-left-top status-cell" style="vertical-align: top">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select [options]="statuses" appendTo="body" name="testDataTestStatus" [(ngModel)]="testData.teststatus" [style]="{ width: '100%' }">
                  <ng-template pTemplate="selectedItem">
                    @if (testData.teststatus) {
                    <div>
                      <span class="status-highlight" [ngStyle]="getStatusStyle(testData.teststatus)">{{ testData.teststatus }}</span>
                    </div>
                    }
                  </ng-template>

                  <ng-template let-status pTemplate="item">
                    <div>
                      <span class="status-highlight" [ngStyle]="getStatusStyle(status.value)">{{ status.label }} </span>
                    </div>
                  </ng-template>
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                <span class="status-highlight" [ngStyle]="getStatusStyle(testData.teststatus)">{{ testData.teststatus }}</span>
              </ng-template>
            </p-cellEditor>
          </td>

          <td>
            @if (!readOnly) {
            <mat-icon style="cursor: pointer" (click)="onAddTestStep(testData.id)">add</mat-icon>
            <mat-icon style="cursor: pointer" (click)="onDuplicateTestStep(testData.id)">content_copy</mat-icon>
            <mat-icon style="cursor: pointer" (click)="onDeleteTestStep(testData)">delete</mat-icon>
            }
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorleft">
        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="onExportExcel()" class="p-mr-2 m-r-5" title="Export to excel" tooltipPosition="bottom" style="background: gray"></button>
        @if (inputTableData?.length === 0 && !readOnly) {
        <mat-icon style="cursor: pointer" (click)="onAddTestStep(0)">add</mat-icon>
        }
      </ng-template>
    </p-table>
  </div>
</div>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
